import { createFileRoute } from "@tanstack/react-router";

import { OwnerSiteHome } from "../../../../areas/owner/home/OwnerPages";

export const Route = createFileRoute("/portal/_owner/sites/$siteId")({
  component: OwnerSite,
});

function OwnerSite() {
  const { siteId } = Route.useParams();
  return <OwnerSiteHome siteId={siteId} />;
}
